export default {
    header: {
        heading: 'Evaluation elements',
        description: 'Check what will be part of this cycle.',
    },
    types: {
        managerAssessment: {
            label: 'Assessment by {{managerLabel}}',
            description:
                "Each {{managerLabel}} provides an evaluation of their employee's performance.",
        },
        feedback360: {
            label: '360 feedback',
            description: 'Collect feedback from peers and employees.',
        },
        selfAssessment: {
            label: 'Self-assessment',
            description: 'The employee reflects on their own performance.',
        },
    },
    subOptions: {
        assessCompetencies: 'Assess competencies',
        required: 'required',
        assessOrganizationalValues: 'Assess organizational values',
    },
    template: {
        label: 'Evaluation template',
        placeholder: 'Choose a template',
        noAdditionalTemplate: 'No additional template',
        managerHint:
            'The assessment by {{managerLabel}} covers competencies, and you can also add a template of extra questions.',
        noneAvailable: 'No template exists for this evaluation type yet.',
        createOne: 'Manage templates',
    },
    validation: {
        atLeastOneType: 'Select at least one evaluation type.',
        templateRequired: 'Choose a template for each checked evaluation.',
        cannotRemoveSentType:
            'This evaluation has already been sent and cannot be removed from the cycle.',
        templateNoLongerAvailable:
            'The selected template is no longer available. Choose another one.',
    },
};
